import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackEvent } from '../lib/metaPixel';
export const Offer = () => {
  return <Section id="offer" className="bg-beige/30 pb-24" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-terracotta/20" data-id="element-136">
          <div className="bg-terracotta text-white text-center py-4 font-medium tracking-wide uppercase text-sm" data-id="element-137">
            Oferta Especial por Tiempo Limitado
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-138">
            <h2 className="text-2xl md:text-3xl font-serif font-medium text-charcoal mb-6 leading-relaxed" data-id="element-139">
              Recupera la paz en tu cocina y el respeto de tus hijos por menos
              de lo que cuesta una salida a comer fuera.
            </h2>

            <div className="my-10" data-id="element-140">
              <p className="text-charcoal/60 uppercase tracking-widest text-sm font-semibold mb-2" data-id="element-141">
                Inversión única
              </p>

              <div className="flex flex-col items-center gap-2" data-id="element-142">
                <div className="flex items-center gap-2" data-id="element-143">
                  <span className="text-2xl font-serif text-charcoal/40 line-through decoration-terracotta/60 decoration-2" data-id="element-144">
                    $19 USD
                  </span>
                  <span className="bg-terracotta/10 text-terracotta text-xs font-bold uppercase tracking-wider px-2 py-1 rounded-full" data-id="element-145">
                    -66%
                  </span>
                </div>

                <div className="flex items-start justify-center gap-1" data-id="element-146">
                  <span className="text-3xl font-serif text-terracotta font-bold mt-2" data-id="element-147">
                    $
                  </span>
                  <span className="text-7xl font-serif text-terracotta font-bold leading-none" data-id="element-148">
                    6.39
                  </span>
                  <span className="text-xl font-serif text-terracotta font-medium mt-8" data-id="element-149">
                    USD
                  </span>
                </div>

                <p className="text-sm text-charcoal/60 italic mt-1" data-id="element-150">
                  Precio promocional por tiempo limitado
                </p>
              </div>
            </div>

            <div id="cta-final" className="max-w-md mx-auto scroll-mt-24" data-id="element-151">
              <Button className="py-5 shadow-xl shadow-terracotta/20" onClick={e => {
              e.preventDefault();
              const checkoutUrl = 'https://soscalma.com/cart/53240899895609:1';
              trackEvent('AddToCart', {
                content_name: 'El Escudo de los 3 Segundos',
                content_ids: ['53240899895609'],
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
              // Give the pixel ~400ms to fire its network request
              // before we navigate away from the page.
              setTimeout(() => {
                window.location.href = checkoutUrl;
              }, 400);
            }} data-id="element-152">
                ¡QUIERO MI GUÍA Y RECUPERAR MI PAZ AHORA!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};